import { Component, OnInit } from '@angular/core';
import { AdminServiceService } from 'src/app/services/admin-service.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-edit-plans',
  templateUrl: './edit-plans.component.html',
  styles: [
  ]
})
export class EditPlansComponent implements OnInit {

  public plans = [];
  constructor(
    private adminService:AdminServiceService,
  ) {

    this.adminService.getPlans().subscribe(
      resp=>{
        this.plans = resp;
      },
      err=>console.log(err)
    )

  }

  ngOnInit(): void {
  }


  updatePlan(plan){
    this.adminService.updatePlan(plan).subscribe(
      resp=>{
        Swal.fire("Plan actualizado");
      },
      err=>console.log(err)
    )
  }

}
